import { render, staticRenderFns } from "./SurveyManagementQuestionPreview.vue?vue&type=template&id=01912d66&scoped=true&"
import script from "./SurveyManagementQuestionPreview.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementQuestionPreview.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementQuestionPreview.vue?vue&type=style&index=0&id=01912d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01912d66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01912d66')) {
      api.createRecord('01912d66', component.options)
    } else {
      api.reload('01912d66', component.options)
    }
    module.hot.accept("./SurveyManagementQuestionPreview.vue?vue&type=template&id=01912d66&scoped=true&", function () {
      api.rerender('01912d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/question-preview/SurveyManagementQuestionPreview.vue"
export default component.exports